exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-file[data-v-fae5bece] {\r\n  max-width: 500px !important;\n}\r\n\r\n/* Decrease the default text size of drop-down options */\n.demo[data-v-fae5bece], .dropdown-item[data-v-fae5bece] {\r\n  font-size: 0.75rem !important;\n}\n.dropdown-menu hr[data-v-fae5bece] {\r\n  margin: 5px 0;\n}\r\n\r\n/* Change the link select color from Bootstrap primary blue */\n.dropdown-item[data-v-fae5bece]:active {\r\n  background-color: #D1ECF1;\n}\n.align-with-header[data-v-fae5bece] {\r\n  margin-top: -50px;\r\n  float: right;\n}\r\n\r\n", ""]);

// exports
